import { render, staticRenderFns } from "./CustomerStatement.vue?vue&type=template&id=edce970c&scoped=true&"
import script from "./CustomerStatement.vue?vue&type=script&lang=js&"
export * from "./CustomerStatement.vue?vue&type=script&lang=js&"
import style0 from "./CustomerStatement.vue?vue&type=style&index=0&id=edce970c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edce970c",
  null
  
)

export default component.exports